const initialState = {
  list: [],
  totalRows: 25,
  loading: 'idle',
  numberList: [],
  numberListLoading: 'idle',

  selectedItem: {
    data: null,
    loading: 'idle',
  },

  result: {
    data: null,
    loading: 'idle',
  },

  pending: {
    data: [],
    loading: 'idle',
  },

  tobaccoTypes: {
    data: [],
    loading: 'idle',
  },

  conveyorSteps: {
    data: [],
    loading: 'idle',
  },
};

export default initialState;
